import React, {useState} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

import ProfileLink from '../ProfileLink';
import {LocalizedLink} from '../ReactRouterDomLocalized';
import {FILM_STATUS_PUBLISHED} from '../../constants/amateurFilms';
import {formatDate, getMSLength, getStatus} from '../../utils/amateurFilms';
import ModalConfirmPostDelete from '../modals/ModalConfirmPostDelete';

const AmateurFilmItem = ({
        amateurFilm,
        currentUser = false,
        showAuthor = false,
        showDate = false,
        showStats = false,
        onDelete = false,
        location,
    }) => {
    const [showModal, setShowModal] = useState(false);
    let overlayContent = null;

    if (amateurFilm.status === FILM_STATUS_PUBLISHED) {
        overlayContent = <div className='play'/>;
    } else {
        overlayContent = <div className='status'>{getStatus(amateurFilm)}</div>;
    }

    const isMembre = currentUser && currentUser.id === amateurFilm.user.id;

    let deleteFn;
    if (onDelete && isMembre) {
        deleteFn = () => setShowModal(true);
    }

    return (
        <div className='amateur-film-list-item'>
            {deleteFn && <div className='delete' onClick={deleteFn}/>}
            <LocalizedLink to={(amateurFilm.url.slice(0, -1)) + location.hash + `${location.hash ? "&" : "#"}context=${isMembre ? 'member' : 'profile'}`} className='thumbnail'>
                <div className='thumbnail'>
                    <img src={amateurFilm.thumbnail_url} alt={amateurFilm.description}/>
                    <div className='fon-get-film'>
                        {overlayContent}
                    </div>
                    <div className='time'>{getMSLength(amateurFilm)}</div>
                </div>
            </LocalizedLink>
            <div className='text'>
                {showAuthor &&
                <div className='author-block'>
                    <div className='author-img'>
                        <img src={amateurFilm.user.avatar_url} alt=''/>
                    </div>
                    <div className='author-name'>
                        <ProfileLink user={amateurFilm.user}/>
                    </div>
                </div>
                }
                <p className='title'>
                    {amateurFilm.name}
                </p>
                {showDate && <p className='date'>{formatDate(amateurFilm)}</p>}
            </div>
            {showStats &&
            <div className='static space-between'>
                <div className='views'>{amateurFilm.views}</div>
                <div className={amateurFilm.is_liked ? 'like highlight' : 'like'}>{amateurFilm.like_count}</div>
                <div className='message'>{amateurFilm.comment_count}</div>
            </div>
            }
            <ModalConfirmPostDelete show={showModal} post={amateurFilm} closeFn={() => setShowModal(false)} />
        </div>
    )
};

const mapStateToProps = state => ({
    profile: state.profile
});

export default connect(mapStateToProps)(withRouter(AmateurFilmItem));



// WEBPACK FOOTER //
// ./src/components/amateurfilms/AmateurFilmItem.js